import { Controller } from '@cherrypulp/trunk';
// import AOS from 'aos';

export default class DefaultController extends Controller {
    /**
     * Condition to execute controller.
     * @return {boolean}
     */
    isActive() {
        return true;
    }

    /**
     * Mounted.
     */
    mounted() {
        document.documentElement.classList.add("js");

        const header = document.querySelector('.main-header');
        const btn = document.querySelector('.burger-button');
        const responsive = document.querySelector('.responsive-menu');

        if ( btn ) {
            btn.addEventListener('click', function () {
                document.body.classList.toggle('responsive-menu-opened');
                btn.classList.toggle('opened');
                responsive.classList.toggle('opened');
            } );
        }

        const handleScroll = () => {
            if ( window.scrollY >= 30 ) {
                header.classList.add('fixed');
                responsive.style.top = '76px';
            } else {
                header.classList.remove('fixed');
                responsive.style.top = '108px';
            }
        };

        const is_not_funnel = !( document.body.classList.contains('template-funnel') ||
            document.body.classList.contains('template-appointment') ||
            document.body.classList.contains('template-contract') );

        if ( is_not_funnel ) {
            handleScroll();

            window.addEventListener('scroll', handleScroll );
        }
    }
}
